import { nextTick, type App, watch } from 'vue';
import type { Router } from 'vue-router';
import { useUserStore } from '@/plugins/pinia/userStore.ts';
import { installApplicationInsights } from '@/plugins/analytics/app-insights';
import { installGoogleTagManager, loadGoogleTagManager } from '@/plugins/analytics/google-tag-manager';

export const initializeAnalyticsOnConsent = (app: App, router: Router) => {
  const user = useUserStore();

  const appInsights = installApplicationInsights();
  installGoogleTagManager(app);

  if (appInsights) {
    void router.isReady().then(async () => {
      await nextTick();
      appInsights.trackPageView({
        name: document.title,
        uri: window.location.href,
      });
    });
  }

  watch(() => user.cookieConsent, loadGoogleTagManager, { immediate: true });
};
